'use client';

import { useFloating } from "../../../../external/@floating-ui/react/dist/floating-ui.react.js";
import { mergeRefs } from "../../../utils/props/mergeRefs.js";
import { autoUpdate } from "../../../../external/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset, size, flip, shift } from "../../../../external/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
const gapBeforeListDropdown = 4;
function useFloatingUi({
  isOpen,
  onOpenChange,
  triggerRef,
  wrapperRef
}) {
  const params = {
    placement: "bottom-start",
    open: isOpen,
    onOpenChange,
    middleware: [
      offset(gapBeforeListDropdown),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`
          });
        }
      }),
      flip(),
      shift()
    ],
    transform: true,
    whileElementsMounted: autoUpdate
  };
  const { refs, floatingStyles } = useFloating(params);
  return {
    dropdownProps: {
      ref: wrapperRef ? mergeRefs(refs.setFloating, wrapperRef) : refs.setFloating,
      style: floatingStyles
    },
    triggerProps: {
      ref: triggerRef ? mergeRefs(refs.setReference, triggerRef) : refs.setReference
    }
  };
}
export {
  useFloatingUi
};
